import React from 'react';
import { observer } from "mobx-react";
import { AnyQuestions } from "../../components/block/AnyQuestions";
import { withStore } from "../../hocs";
import ReactGA from "react-ga";
import { YOUR_TRACKING_ID } from "../../stores/AppStore";
import { Button, TextField, Paper, Box } from "@mui/material";
import { SynonymsEditor } from "../../components/admin/SynonymsEditor";
import { ADMIN_ROUTE_PATHS } from "../../constants/adminRoutes";

// @ts-ignore
@withStore
@observer
export default class AdminSystemProps extends React.Component {
    setGA = () => {
        ReactGA.initialize(YOUR_TRACKING_ID);
        ReactGA.pageview(window.location.pathname + window.location.search);
    };

    componentDidMount() {
        // @ts-ignore
        const { store } = this.props;
        store?.pageAdminAuthStore.getAllSystemProps();
        this.setGA();
    }

    render() {
        // @ts-ignore
        const { store } = this.props;
        const { 
            arrSystemProps, 
            onChangeSystemProps, 
            saveUserPrompt,
            saveSystemPrompt,
            saveSynonyms,
            updateSynonyms
        } = store?.pageAdminAuthStore;

        // Получаем единственную запись или создаем пустую для редактирования
        const currentRow = arrSystemProps && arrSystemProps.length > 0 
            ? arrSystemProps[0] 
            : { id: null, userPrompt: '', systemPrompt: '', synonyms: {} };

        // Убеждаемся, что synonyms это объект
        const synonyms = typeof currentRow.synonyms === 'object' && currentRow.synonyms !== null
            ? currentRow.synonyms as { [key: string]: (number | string)[] }
            : {};

        return (
            <>
                <main className="page__main">
                    <div className="container">
                        <ul className="breadcrumbs">
                            <li className="breadcrumbs__item"><a className="breadcrumbs__link" href="/">Главная</a></li>
                            <li className="breadcrumbs__item"><a className="breadcrumbs__link"
                                href={ADMIN_ROUTE_PATHS.base}>Администрирование</a></li>
                            <li className="breadcrumbs__item">Массив сопоставлений для поиска</li>
                        </ul>
                    </div>

                    <div style={{ padding: 20 }}>
                        <h2 style={{ fontSize: 18, fontWeight: "bold" }}>Массив сопоставлений для поиска</h2>
                        {currentRow.id && (
                            <p style={{ color: '#666', fontSize: 14, marginTop: 5 }}>
                                ID записи: {currentRow.id}
                            </p>
                        )}
                    </div>

                    {/* User Prompt секция */}
                    <Box style={{ width: "95%", margin: "auto", marginBottom: 20 }}>
                        <Paper style={{ padding: 20 }}>
                            <h3 style={{ margin: 0, marginBottom: 15 }}>User Prompt</h3>
                            <TextField 
                                fullWidth
                                onChange={(e) => { 
                                    onChangeSystemProps(currentRow.id || 'new', "userPrompt", e.target.value) 
                                }} 
                                defaultValue={currentRow.userPrompt || ''} 
                                id="userPrompt"
                                variant="outlined" 
                                rows={6} 
                                multiline 
                                placeholder="Введите User Prompt..."
                            />
                            <Box style={{ marginTop: 15, display: 'flex', justifyContent: 'flex-end' }}>
                                <Button 
                                    style={{ backgroundColor: "#d1a0a9" }} 
                                    onClick={() => saveUserPrompt()} 
                                    variant="contained"
                                >
                                    Сохранить изменения
                                </Button>
                            </Box>
                        </Paper>
                    </Box>

                    {/* System Prompt секция */}
                    <Box style={{ width: "95%", margin: "auto", marginBottom: 20 }}>
                        <Paper style={{ padding: 20 }}>
                            <h3 style={{ margin: 0, marginBottom: 15 }}>System Prompt</h3>
                            <TextField 
                                fullWidth
                                onChange={(e) => { 
                                    onChangeSystemProps(currentRow.id || 'new', "systemPrompt", e.target.value) 
                                }} 
                                defaultValue={currentRow.systemPrompt || ''} 
                                id="systemPrompt"
                                variant="outlined" 
                                rows={6} 
                                multiline 
                                placeholder="Введите System Prompt..."
                            />
                            <Box style={{ marginTop: 15, display: 'flex', justifyContent: 'flex-end' }}>
                                <Button 
                                    style={{ backgroundColor: "#d1a0a9" }} 
                                    onClick={() => saveSystemPrompt()} 
                                    variant="contained"
                                >
                                    Сохранить изменения
                                </Button>
                            </Box>
                        </Paper>
                    </Box>

                    {/* Synonyms секция */}
                    <Box style={{ width: "95%", margin: "auto", marginBottom: 20 }}>
                        <Paper style={{ padding: 20 }}>
                            <h3 style={{ margin: 0, marginBottom: 15 }}>Synonyms</h3>
                            <SynonymsEditor 
                                synonyms={synonyms}
                                onChange={(newSynonyms) => {
                                    updateSynonyms(newSynonyms);
                                }}
                            />
                            <Box style={{ marginTop: 15, display: 'flex', justifyContent: 'flex-end' }}>
                                <Button 
                                    style={{ backgroundColor: "#d1a0a9" }} 
                                    onClick={() => saveSynonyms()} 
                                    variant="contained"
                                >
                                    Сохранить изменения
                                </Button>
                            </Box>
                        </Paper>
                    </Box>

                    <br />
                    <AnyQuestions />
                </main>
            </>
        )
    }
}
